<div class="pdf-overlay" @overlayAnim>
        <div class="pdf-card" @cardAnim [class.is-excel]="(variant$ | async) === 'excel'">

        <!-- Anillos orbitando -->
        <div class="rings-wrapper" aria-hidden="true">
            <div class="ring ring-1"></div>
            <div class="ring ring-2"></div>
            <div class="ring ring-3"></div>

            <!-- Icono central -->
            <div class="icon-wrap">

                @if((variant$ | async) === 'excel') {
                    <!-- Icono Excel -->
                    <svg class="excel-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <!-- Documento base -->
                        <rect x="10" y="4" width="36" height="48" rx="4" fill="#16a34a" />
                        <rect x="10" y="4" width="36" height="48" rx="4" stroke="#15803d" stroke-width="1.5"/>
                        <!-- Esquina doblada -->
                        <path d="M36 4 L46 14 L36 14 Z" fill="#15803d"/>
                        <path d="M36 4 L36 14 L46 14" stroke="#166534" stroke-width="1.5" fill="none"/>
                        <!-- Grilla animada -->
                        <rect class="line line-1" x="14" y="20" height="3" rx="1" fill="white" fill-opacity="0.9"/>
                        <rect class="line line-2" x="14" y="27" height="3" rx="1" fill="white" fill-opacity="0.9"/>
                        <rect class="line line-3" x="14" y="34" height="3" rx="1" fill="white" fill-opacity="0.9"/>
                        <!-- Línea vertical divisora -->
                        <line x1="28" y1="18" x2="28" y2="40" stroke="rgba(255,255,255,0.3)" stroke-width="1"/>
                        <!-- Etiqueta XLS -->
                        <text x="50%" y="88%" text-anchor="middle" font-size="10" font-weight="700"
                              font-family="Arial, sans-serif" fill="#15803d" letter-spacing="1">XLS</text>
                    </svg>
                } @else {
                    <!-- Icono PDF -->
                    <svg class="pdf-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="10" y="4" width="36" height="48" rx="4" fill="#e53e3e" />
                        <rect x="10" y="4" width="36" height="48" rx="4" stroke="#c53030" stroke-width="1.5"/>
                        <path d="M36 4 L46 14 L36 14 Z" fill="#c53030"/>
                        <path d="M36 4 L36 14 L46 14" stroke="#9b2c2c" stroke-width="1.5" fill="none"/>
                        <rect class="line line-1" x="16" y="22" height="3" rx="1.5" fill="white" fill-opacity="0.85"/>
                        <rect class="line line-2" x="16" y="29" height="3" rx="1.5" fill="white" fill-opacity="0.85"/>
                        <rect class="line line-3" x="16" y="36" height="3" rx="1.5" fill="white" fill-opacity="0.85"/>
                        <text x="50%" y="88%" text-anchor="middle" font-size="10" font-weight="700"
                              font-family="Arial, sans-serif" fill="#c53030" letter-spacing="1">PDF</text>
                    </svg>
                }

                <!-- Glow pulse detrás -->
                <div class="glow-pulse"></div>
            </div>
        </div>

        <!-- Texto -->
        <div class="text-section">
            <p class="generating-text">{{ label$ | async }}</p>
            <div class="dots">
                <span class="dot dot-1"></span>
                <span class="dot dot-2"></span>
                <span class="dot dot-3"></span>
            </div>
            <p class="sub-text">Por favor esperá, esto puede tardar unos segundos.</p>
        </div>
    </div>
</div>
